import React from 'react'
import {Icon} from '@chakra-ui/react'

const RefreshIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.9999 4.69444C15.9406 4.69444 12.0476 6.30699 9.17724 9.17734C6.30689 12.0477 4.69434 15.9407 4.69434 20C4.69434 24.0593 6.30689 27.9523 9.17724 30.8227C12.0476 33.693 15.9406 35.3056 19.9999 35.3056C24.0592 35.3056 27.9522 33.693 30.8226 30.8227C33.6929 27.9524 35.3054 24.0593 35.3054 20H38.3054C38.3054 24.8549 36.3769 29.5111 32.9439 32.944C29.5109 36.377 24.8548 38.3056 19.9999 38.3056C15.145 38.3056 10.4889 36.377 7.05592 32.944C3.62296 29.5111 1.69434 24.855 1.69434 20C1.69434 15.1451 3.62296 10.489 7.05592 7.05602C10.4889 3.62307 15.145 1.69444 19.9999 1.69444C29.7398 1.69444 34.006 8.11524 37.0075 12.6327C37.1028 12.7761 37.1968 12.9175 37.2896 13.0568L34.7935 14.7209C34.731 14.6272 34.6683 14.5331 34.6055 14.4388C31.5606 9.86619 28.1167 4.69444 19.9999 4.69444Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35.3053 12.3889V4.72223H38.3053V15.3889H27.6387V12.3889H35.3053Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default RefreshIcon
